import type {
  FilterStatusMap,
  ItineraryState,
  Itinerary,
  ItineraryById,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/itineraries';

export const get = (state: ItineraryState, id: string): Itinerary => state.byId[id];
export const all = (state: ItineraryState): ItineraryById => state.byId;
export const getFilterStatusMap = (state: ItineraryState, id: string): FilterStatusMap[] =>
  get(state, id)?.upgrades?.filterStatusMap || [];
